var FunderAPI = require("../../common/api/funder");
var AuthStore = require("../../common/auth");
var Geo = require('../../common/geo');
var Category = require('../../common/category');

module.exports = function FunderRegistrationController($scope, $state, $document, ngDialog, $anchorScroll, $location) {
  var vm = this;
  vm.basics = {affiliated:false};
  vm.fundingInformation = {};
  vm.financialInformation = {};
  vm.submit = {};
  vm.funderId = null;
  vm.selectedGeographicAreas = [];
  vm.selectedCategories = [];
  vm.unusedAreas = [];
  vm.unusedCategories = [];
  vm.areas = [];
  vm.currentYear = 0;
  vm.recentYears = {
    oneYearAgo: -1,
    twoYearsAgo: -2,
    threeYearsAgo: -3
  };

  vm.photoCounter = 1;
  vm.photoArray = [{id:1, photo:{}}];

  vm.getPhotoCounter = function() {
    return vm.photoArray;
  }

  vm.goToTop = function(){
    $location.hash('top');
    $anchorScroll();
  }


  vm.incrementPhoto = function() {
    vm.photoCounter = vm.photoCounter+1;
    vm.photoArray.push({id:vm.photoCounter+1, photo:{}});
  }

  vm.removePhoto = function(id) {
    for(var i = 0; i < vm.photoArray.length; i++){
      if (vm.photoArray[i].id == id) {
        vm.photoArray.splice(i,1);
        break;
      }
    }
  }

  vm.clearNav = function() {
    vm.basicsActive = false;
    vm.fundingInformationActive = false;
    vm.financialInformationActive = false;
    vm.submitActive = false;
  };

  vm.submitForm = function(opts) {
    if(Array.isArray(vm.basics.logo)){
      vm.basics.logo = vm.basics.logo[0];
    }
    opts = opts || {}
    var request = {
      userPosition: vm.basics.userPosition,
      displayUserPosition: vm.basics.displayUserPosition,
      name: vm.basics.organisationName,
      address: {
        addressLine1: vm.basics.addressLine1,
        addressLine2: vm.basics.addressLine2,
        addressLine3: vm.basics.addressLine3,
        townOrCity: vm.basics.addressTown,
        countyOrState: vm.basics.addressCounty,
        postcodeOrZip: vm.basics.postcode,
        countryId: 1
      },
      displayAddress: vm.basics.displayAddress,
      email: vm.basics.organisationEmail,
      displayEmail: vm.basics.displayEmail,
      telephoneNumber: vm.basics.telephoneNumber,
      displayTelephoneNumber: vm.basics.displayTelephoneNumber,
      websiteUrl: vm.basics.websiteUrl,
      socialMediaItems: vm.basics.socialMediaItems,
      established: vm.basics.established,
      organisationTypes: vm.getOrgTypes(),
      charityNumber: vm.basics.charityNumber,
      companyNumber: vm.basics.companyNumber,
      organisationDetails: vm.basics.orgDetails,
      isAffiliated: vm.basics.affiliated,
      affiliatedDetails: vm.basics.affiliatedDetails,
      organisationManagedBy : vm.basics.orgManaged,
      organisationManagedDetails: vm.basics.managedDetails,
      organisationOverview: vm.basics.orgOverview,
      areasServed: vm.basics.areasServed,
      charitableCategories: vm.basics.charitableCategories,
      charitableFunding: vm.basics.charitableFunding,
      totalFundingDistributed: vm.basics.totalFundingDist,
      numberOrgsFunded: vm.basics.numOrgsFunded,
      totalGrantsLastYear: vm.basics.totalGrantsLastYear,
      totalCharityExpenditure: vm.basics.totalCharityExpenditure,
      SupportedProjectTypes: vm.getSupportedProjectTypes(),
      fundingPriorities: vm.basics.fundingPriorities,
      importantToFunder: vm.basics.importantToFunder,
      logo: vm.basics.logo,
      photos: vm.getPhotosToSend(),
      report: vm.basics.report,
      authorityStatement: vm.basics.authorityStatement,
      account: vm.basics.account,
      displayAccount: vm.basics.displayAccount,
      isSubmitted: opts.submitted || false
    };
    $scope.saving = true;
    var p = null;
    if (vm.funderId) {
      request.id = vm.funderId;
      p = FunderAPI.UpdateFunder(request.id, request);
    } else {
      p = FunderAPI.CreateFunder(request).then(function(result) {
        //result is funder id
        vm.funderId = result;
        AuthStore.refresh();
      });
    }
    return p.then(function(){
      if (opts.direction == "back"){
        if ($scope.pane < 1) return;
        $scope.pane = $scope.pane - 1;
      } else {
        if ($scope.pane > 5) return;
        $scope.pane = $scope.pane + 1;
      }
    }).finally(function(){
      $scope.saving = false;
    })
  };

  vm.saveForLater = function() {
    var dialog = ngDialog.open({
      template: require("./dialogs/saveForLater.pug")(),
      controller: require("./dialogs/saveForLater.js"),
      plain: true,
      disableAnimation: true,
      className: "ge-dialog-medium ngdialog-theme-default",
      resolve: {
        submit: function() {
          return function() {
            return vm.submitForm().then(function() {
              window.location = "/account";
            })
          }
        }
      }
    });
  }

  vm.displaySubmitMessage = function() {
    var dialog = ngDialog.open({
      template: require("./dialogs/submitmessage.pug")(),
      controller: require("./dialogs/submitmessage.js"),
      plain: true,
      disableAnimation: true,
      className: "ge-dialog-medium ngdialog-theme-default",
      resolve: {
        submit: function(){
          return function(){
            return vm.submitForm({submitted:true}).then(function() {
              window.location = "/funder/dashboard";
            })
          }
        }
      }
    });
  }

  vm.preventNavigation = function(bool){
    if (bool === false) {
      window.onbeforeunload = null;
      vm.isPreventingNavigation = false;
      if (vm.stateChangePreventNav) {
        vm.stateChangePreventNav();
        delete vm.stateChangePreventNav;
      }
      return
    }

    vm.isPreventingNavigation = true;
    window.onbeforeunload = function(e) {
      e = e || window.event;

      if (e) {
        e.returnValue = message;
      }

      return message;
    };

    // return early if already set up
    if (vm.stateChangePreventNav) return;
    vm.stateChangePreventNav = $rootScope.$on("$stateChangeStart", function(e, toState, toParams, fromState, fromParams) {
      e.preventDefault();
      vm.triggerPreventNavigation().then(function(){
        $state.go(toState, toParams);
      })
    })

  }

  vm.saveGeographic = function() {
    var areaList = vm.selectedGeographicAreas.map(function(elem) {
      return elem.name;
    }).join(", ");
    vm.fundingInformation.geographicAreas = areaList;
  };
  vm.init = function() {
    vm.basicsActive = true;
		FunderAPI.GetCurrentFunder("FunderDetailsView").then(function(result) {
      if (result) {
        vm.funderId = result.id;
        vm.basics = {
          organisationName: result.name,
          telephoneNumber: result.telephoneNumber,
          displayTelephoneNumber: result.displayTelephoneNumber,
          websiteUrl: result.websiteUrl,
          addressLine1: result.address.addressLine1,
          addressLine2: result.address.addressLine2,
          addressLine3: result.address.addressLine3,
          addressTown: result.address.townOrCity,
          addressCounty: result.address.countyOrState,
          postcode: result.address.postcodeOrZip,
          displayAddress: result.displayAddress,
          userPosition: result.userPosition,
          displayUserPosition: result.displayUserPosition,
          organisationEmail: result.email,
          displayEmail: result.displayEmail,
          socialMediaItems: result.socialMediaItems,
          established: result.established,

          charitableTrust: result.organisationTypes.indexOf(1) != -1,
          charitableFoundation: result.organisationTypes.indexOf(2) != -1,
          regCharity: result.organisationTypes.indexOf(3) != -1,
          limitedGuar: result.organisationTypes.indexOf(4) != -1,
          limitedShares: result.organisationTypes.indexOf(5) != -1,
          solicitor: result.organisationTypes.indexOf(6) != -1,
          socialHousing: result.organisationTypes.indexOf(7) != -1,
          cic: result.organisationTypes.indexOf(8) != -1,
          cio: result.organisationTypes.indexOf(9) != -1,
          localAuth: result.organisationTypes.indexOf(10) != -1,
          socialInvest: result.organisationTypes.indexOf(11) != -1,
          liveryComp: result.organisationTypes.indexOf(12) != -1,
          clubs: result.organisationTypes.indexOf(13) != -1,
          ltdPart: result.organisationTypes.indexOf(14) != -1,
          other: result.organisationTypes.indexOf(15) != -1,

          orgDetails: result.organisationDetails,
          charityNumber: result.charityNumber,
          companyNumber: result.companyNumber,
          affiliated: result.isAffiliated,
          affiliatedDetails: result.affiliatedDetails,
          orgManaged: result.organisationManagedBy.toString(),
          managedDetails: result.organisationManagedDetails,
          orgOverview: result.organisationOverview,
          areasServed: result.areaServed,
          charitableCategories: result.selectedCharitableCategories,
          charitableFunding: result.charitableFunding,
          totalFundingDist: result.totalFundingDistributed,
          numOrgsFunded: result.numberOrgsFunded,
          totalGrantsLastYear: result.totalGrantsLastYear,
          totalCharityExpenditure: result.totalCharityExpenditure,
          fundingPriorities: result.fundingPriorities,
          importantToFunder: result.importantToFunder,

          capital: result.supportedProjectTypes.indexOf(1) != -1,
          revenueCore: result.supportedProjectTypes.indexOf(2) != -1,
          revenueNonCore: result.supportedProjectTypes.indexOf(3) != -1,
          transformationalImpact: result.supportedProjectTypes.indexOf(4) != -1,

          logo: result.logo,
          account: result.account,
          displayAccount: result.displayAccount,
          report: result.report,
          authorityStatement: result.authorityStatement
        };

        vm.photoArray = vm.parsePhotosFromServer(result.photos);

        // KJ note 30/08/2016 - looks to be unused
        /*
        vm.financialInformation = {
          annualTurnover: result.annualTurnover,
          oneYear: result.oneYear,
          twoYears: result.twoYears,
          threeYears: result.threeYears,
          publicPreviousFunding: result.publicFundingPrevious,
          publicFund: result.publicFund,
        };
        */
      }
    });
  };

  vm.getOrgTypes = function() {
    var orgTypes = [];
    vm.basics.charitableTrust && orgTypes.push(1);
    vm.basics.charitableFoundation && orgTypes.push(2);
    vm.basics.regCharity && orgTypes.push(3);
    vm.basics.limitedGuar && orgTypes.push(4);
    vm.basics.limitedShares && orgTypes.push(5);
    vm.basics.solicitor && orgTypes.push(6);
    vm.basics.socialHousing && orgTypes.push(7);
    vm.basics.cic && orgTypes.push(8);
    vm.basics.cio && orgTypes.push(9);
    vm.basics.localAuth && orgTypes.push(10);
    vm.basics.socialInvest && orgTypes.push(11);
    vm.basics.liveryComp && orgTypes.push(12);
    vm.basics.clubs && orgTypes.push(13);
    vm.basics.ltdPart && orgTypes.push(14);
    vm.basics.other && orgTypes.push(15);
    return orgTypes;
  }

  vm.getSupportedProjectTypes = function() {
    var projTypes = [];
    vm.basics.capital && projTypes.push(1);
    vm.basics.revenueCore && projTypes.push(2);
    vm.basics.revenueNonCore && projTypes.push(3);
    vm.basics.transformationalImpact && projTypes.push(4);
    return projTypes;
  }

  vm.addGeo = function(e){
    e.preventDefault();
    var dialog = ngDialog.open(Geo.Dialog({value: vm.basics.areasServed}));

    dialog.closePromise.then(function(obj) {
      if (obj.value.action == "cancel") return;
      if (obj.value.action == "save") {
        vm.basics.areasServed = obj.value.value;
      }
    })
  }

  vm.addCategory = function(e){
    e.preventDefault();
    var dialog = ngDialog.open(Category.Dialog({value: vm.basics.charitableCategories}));

    dialog.closePromise.then(function(obj) {
      if (obj.value.action == "cancel") return;
      if (obj.value.action == "save") {
        vm.basics.charitableCategories = obj.value.value;
      }
    })
  }

  vm.logoChanged = function(request) {
    request.logo.blobId = request.logo.id;
  }

  vm.photoChanged = function(id) {
    for (var i = 0; i < vm.photoArray.length; i++) {
      if(vm.photoArray[i].id == id) {
        vm.photoArray[i].photo.blobId = vm.photoArray[i].photo.id;
        break;
      }
    }
  }

  vm.getPhotosToSend = function() {
    var serverPhotos = [];
    for (var i = 0; i < vm.photoArray.length; i++) {
      if (vm.photoArray[i].photo && vm.photoArray[i].photo.blobId) {
        serverPhotos.push(vm.photoArray[i].photo);
      }
    }
    return serverPhotos;
  }

  vm.parsePhotosFromServer = function(serverPhotos) {
    var photos = [];
    for (var i = 0; i < serverPhotos.length; i++) {
      var serverPhoto = serverPhotos[i];
      photos.push({
        id: serverPhoto.blobId,
        photo: serverPhoto
      });
    }
    return photos;
  }

  vm.reportChanged = function(request) {
    request.report.blobId = request.report.id;
  }
  vm.accountChanged = function(request) {
    request.account.blobId = request.account.id;
  }

  vm.authorityStatementChanged = function(request) {
    request.authorityStatement.blobId = request.authorityStatement.id;
  }

  vm.init();
};
